import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialCardProps) {
  // Generate initials from name
  const initials = name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  return <div className="bg-gray-900 border border-gray-800 p-6 rounded-xl flex flex-col h-full" data-id="element-41">
      <div className="flex space-x-1 mb-4" data-id="element-42">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-43" />)}
      </div>

      <blockquote className="flex-grow mb-6" data-id="element-44">
        <p className="text-gray-300 italic text-lg leading-relaxed" data-id="element-45">
          "{content}"
        </p>
      </blockquote>

      <div className="flex items-center mt-auto" data-id="element-46">
        <div className="flex-shrink-0 mr-4" data-id="element-47">
          {image ? <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover border-2 border-gray-700" data-id="element-48" /> : <div className="w-12 h-12 rounded-full bg-gray-700 flex items-center justify-center text-white font-bold border-2 border-gray-600" data-id="element-49">
              {initials}
            </div>}
        </div>
        <div data-id="element-50">
          <h4 className="text-white font-bold text-base" data-id="element-51">{name}</h4>
          <p className="text-gray-500 text-sm" data-id="element-52">{role}</p>
        </div>
      </div>
    </div>;
}